import React, { useState, useEffect } from "react";
import { Stack } from "@mui/material";
import axios from "axios";
import _ from "lodash";
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import "./planogram.css";
import { makeStyles } from '@mui/styles';
import { useDrag } from '@use-gesture/react';
import { useSpring, animated } from '@react-spring/web';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Collapse } from "@mui/material";
import moment from "moment";
import { planogramActions, planogramProjectInfoActions } from "../store/store";
import { useSelector, useDispatch } from "react-redux";
import { PlanogramSnackbar } from "./planogram_components/snackbar";
import { DotLoader } from "./planogram_components/dot_loader";
import Default from "./tabs/default";
import Filters from "./tabs/filters";

const menu_header_styles = { 
  display: "flex",
  justifyContent: "space-between", 
  alignItems: "center",
  width: "17rem",
  padding: "0.35rem 0.65rem",
  boxSizing: "border-box",
  boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)",
  borderRadius: "10px",
  backgroundColor: "rgb(41,45,57)",
  fontFamily: "Josefin Sans",
}

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default function PlanogramMenu(props) {
  const pos = useSelector(state => state.planogramStore.pos);
  const openMenu = useSelector(state => state.planogramStore.openMenu);
  const selectedPage = useSelector(state => state.planogramStore.page);
  const dispatch = useDispatch();

  const bind = useDrag(({ event, offset: [x, y] }) => {
    const targetClasses = event.target.classList;

    // Check if the drag icon is being dragged
    if (targetClasses.contains('drag-indicator-dark')) {
      dispatch(planogramActions.setPos({ x: x + (window.innerWidth - 325), y: y + 100 }))
    }
  });

  const navigate = useNavigate();
  const [springs, api] = useSpring(() => ({
    from: {
      x: window.innerWidth - 300
    },
    config: {
      mass: 2.5,
    }
  }))

  useEffect(() => {
    dispatch(planogramActions.setPos(pos));
  }, [pos, dispatch]);
  

  useEffect(() => {
    api.start({
      from: {
        x: "-100%",
        scale: 0
      },
      to: {
        x: "0%",
        scale: 1
      }
    })
  }, [openMenu])

  useEffect(() => {
    setInterval(() => {
      const updatedDateTime = moment(new Date()).format("MMM DD, YYYY hh:mm:ss a");
      dispatch(planogramProjectInfoActions.updateDateTime(updatedDateTime))
    }, 1000)
  }, [])

  const handleMenuOpen = () => {
    dispatch(planogramActions.setPos({ x: pos.x, y: pos.y }));
    dispatch(planogramActions.setopenMenu(!openMenu))
  }

  useEffect(() => { }, [selectedPage])

  useEffect(() => {
    setInterval(() => {
      const updatedDateTime = moment(new Date()).format("MMM DD, YYYY hh:mm:ss a");
      dispatch(planogramProjectInfoActions.updateDateTime(updatedDateTime))
    }, 1000)
  }, [])

  const pages = [
    {
      name: "default",
      page: (
        <Default />
      )
    },
    {
      name: "filters",
      page: (
        <Filters />
      )
    }
  ]

  const handlePageChange = () => {
    dispatch(planogramActions.changePage("preferences"));
    dispatch(planogramActions.setPrevPage(selectedPage));
  }

  const currentPage = pages.filter(page => page.name === selectedPage)[0]["page"]

  return (
    <animated.div
      {...bind()}
      style={{
        position: "fixed",
        zIndex: 999,
        top: pos.y,
        left: pos.x,
        // ...springs,
      }}
    >

      <Stack spacing={0.7}>
        <div className="drag-indicator-dark" style={menu_header_styles}>
          <div
            onClick={handleMenuOpen}
            style={{
              color: "rgb(250,250,250)",
              fontSize: "1.25rem",
              letterSpacing: "0.02rem",
              cursor: "pointer",
              textShadow: "0 0 3px #fff"
            }}
          >
            Planogram
          </div>
          <div style={{ justifyContent: "center", alignItems: "center" }}>
            <DotLoader />
          </div>
          <DragIndicatorIcon
            sx={{ fontSize: '1.7rem', cursor: 'pointer', transform: "rotate(90deg)"}} 
            onClick={handlePageChange}
          />
        </div>

        <Collapse in={openMenu} timeout={350} unmountOnExit>

          {/* pages */}
          {currentPage}
        </Collapse>

        <PlanogramSnackbar />
      </Stack>
    </animated.div>
  )
}